export const RECESSO_STATE = {
  0: 'Inserito',
  1: 'Attesa RA',
  2: 'Attesa comunicazione da collaboratore',
  3: 'Attesa decorrenza',
  4: 'Rescisso',
  5: 'Non perfezionato',
  6: 'Notizia di recesso',
};



// WEBPACK FOOTER //
// ./app/components/RecessoList/List/constantRecessi.js